module.exports = __webpack_public_path__ + "static/media/Color-Rush-Run-20181028079-HS.50fb441b.jpg";